/**
 * @license lucide v0.469.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */

import defaultAttributes from '../defaultAttributes.js';

const TableOfContents = [
  "svg",
  defaultAttributes,
  [
    ["path", { d: "M16 12H3" }],
    ["path", { d: "M16 18H3" }],
    ["path", { d: "M16 6H3" }],
    ["path", { d: "M21 12h.01" }],
    ["path", { d: "M21 18h.01" }],
    ["path", { d: "M21 6h.01" }]
  ]
];

export { TableOfContents as default };
//# sourceMappingURL=table-of-contents.js.map
